const noop = () => {};
export default function bsNoopHelper() {
  return noop;
}